const reportModal = {
  namespaced: true,
  state: {
    report: null,
    type: null,
    section: 'report'
  },
  mutations: {
    setState(state, {type, report, section}){
      if (report) state.report = report;
      if (type) state.type = type;
      if (section) state.section = section;
    },
    resetState(state){
      state.report = state.type = null;
    }
  },
  actions: {
    openModal({commit}, payload){
      commit('setState', payload);
      document.body.style.overflowY = 'hidden';
    },
    closeModal({commit}){
      commit('resetState');
      document.body.style.overflowY = '';
    }
  }
};

export default reportModal;
